module.exports = __webpack_public_path__ + "static/media/close_btn.90d11fbe.svg";